export default __webpack_public_path__ + "static/media/goodFridayLogo.9d047096.png";